export function getMessage(p_messages, p_index, p_message) {
    let error = p_messages[p_index].label; 
    if (p_message){
        error += " " + p_message;
    }    
    return error;
}  
                  
export function validarPermisos(menu, usuarioPermisos) {
    let permiso = true;
    for (var index = 0; index < menu.permisos.length; index++) {
        if (usuarioPermisos[menu.permisos[index]] != 1) {
            permiso = false;
        }    
     }
    return permiso;
}    

export function isEmpty(p_value) {
    let empty = false;
    if (!p_value && ((p_value === null) || (p_value === undefined)  || (p_value.length == 0))) {
        empty = true;
    }    
    return empty;
}  

export function dataValidate(p_fields, p_messages) {
    let validate = true; 
    for (var index = 0; index < p_fields.length; index++) {
        if (p_fields[index].validate == 1){
            p_fields[index].validation_error = 0;
            p_fields[index].message = '';
            if (isEmpty(p_fields[index].value)) { 
                if (p_fields[index].required == 1) {
                    p_fields[index].validation_error = 1;
                    p_fields[index].message = getMessage(p_messages.data, p_messages.msg_error_1);
                    validate = false;
                }
            }    
        }    
     }
    return validate;
}    

export function dataValidateList(p_fields, p_List, p_messages) {
    let validate = true; 
    for (var index = 0; index < p_List.length; index++) {
        let pos = p_List[index];
        if (p_fields[pos].validate == 1){
            p_fields[pos].validation_error = 0;
            p_fields[pos].message = '';
            if (isEmpty(p_fields[pos].value)) { 
                if (p_fields[pos].required == 1) {
                    p_fields[pos].validation_error = 1;
                    p_fields[pos].message = getMessage(p_messages.data, p_messages.msg_error_1);
                    validate = false;
                }
            }    
        }    
     }
    return validate;
}    

export function updateFields(p_data, p_fields) {
    for (var index = 0; index < p_fields.data.length; index++) {
       if (Array.isArray(p_data)){
            p_fields.data[index].value = p_data[0][p_fields.data[index].field];
        } else {
            p_fields.data[index].value = p_data[p_fields.data[index].field];
        } 
     }  
}

export function createObjectFilter(p_filter, p_fields) {
    let object = new Object();
    object.totalRecord = p_filter.totalRecord;
    object.currentRecord = p_filter.currentRecord;
    for (var index = 0; index < p_fields.data.length; index++) {
        let field = p_fields.data[index].field;
        if (p_fields.data[index].value) {
            object[field] = p_fields.data[index].value;
        } 
    }
    return object;  
}

export function createObjectFields(p_fields, p_usuario) {
    let object = new Object();
    if (!p_fields.data[p_fields.usuario_creacion].value) { 
        p_fields.data[p_fields.usuario_creacion].value =  p_usuario;
    }
    for (var index = 0; index < p_fields.data.length; index++) {
        let field = p_fields.data[index];
        if ((field.estatus == 1) || (field.estatus == 3)){
            if (!isEmpty(field.value)) {
                object[field.field] = field.value;
            }
        } 
    } 
    return object;
}   

export function createObjectFromData(p_fields, p_data, isAll) {
    let object = new Object();
    for (var index = 0; index < p_fields.data.length; index++) {
        let field = p_fields.data[index];
        if (isAll || field.estatus == 1){
            object[field.field] = p_data[0][field.field];
        } 
    }  
    return object;
}   

export function calcularEdad(p_fechaNacimiento, p_fechaLlegada) {
    let hoy = new Date(p_fechaLlegada); //new Date()
    let fechaNacimiento = new Date(p_fechaNacimiento)
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear()
    let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth()
    if (diferenciaMeses < 0 || (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
        edad--
    }
    return edad;
  }

  export function calcularDias(p_fechaInicial, p_fechaFinal) {
    let fechaInicial = new Date(p_fechaInicial);
    let fechaFinal = new Date(p_fechaFinal);
    // Calcular diferencia en milisegundos
    let difference = fechaFinal - fechaInicial;
    // Calcular días
    let differenceDias = (Math.floor(difference / (1000 * 60 * 60 * 24))) + 1;
    return differenceDias;
  }

  export function findTextFromList(p_list, p_idValue){
    let text = "";
    let index = 0
    while ((index < p_list.length) && (text == "")) {
        if (p_idValue == p_list[index].code){
            text = p_list[index].name;
        }
        index++; 
    }    
    return text;
  }

  export function searchForId(list, id, idCampo) {
    let pos = -1;
    let index = 0;
    while ((pos < 0) && (index < list.length)) {
        if (list[index][idCampo] == id) {
            pos = index;
        }
        index++;
    }
    return pos;
}

export function searchRangoEdad(p_list, p_edad) {
    let pos = -1;
    let index = 0;
    while ((pos < 0) && (index < p_list.length)) {
        if ((p_list[index]['desde'] <= p_edad) && (p_list[index]['hasta'] >= p_edad)) {
            pos = index;
        }
        index++;
    }
    return pos;
}

export function newDate(p_date) {
    let date;
    if (p_date){
        date = new Date(p_date);
    } else {
        date = addDays(new Date(), -1);
    }
    let newDate = new Date(date.getFullYear(), (date.getMonth()), date.getDate());
    return newDate;
}

export function dateFormat(p_date, p_format) {
    let date;
    let day = p_date.getDate();
    if(day < 10){
        day = '0' + day;
    }
    let month = p_date.getMonth() + 1;
    if(month < 10){
        month = '0' + month;
    }
    let year = p_date.getFullYear();
    date = year + '-' + month + '-' + day;
    const map = {
        dd: day,
        mm: month,
        yyyy: year
    }
    return p_format.replace(/dd|mm|yyyy/gi, matched => map[matched])
}

export function addDays(p_date, p_days){
    let date = p_date; 
    date.setDate(date.getDate() + p_days);
    return date;
}

export function getNameRouterForTipoSeguro(p_tipoSeguro) {
    let nameRouter = "";
    switch (p_tipoSeguro) {
        case 0:
            nameRouter = "";
            break;
        case 1:
            nameRouter = "cotizacionViajero";
            break;
        case 2:
            nameRouter = "cotizacionBd";
            break;
        case 3:
            nameRouter = "cotizacionSme";
            break;
        case 4:
            nameRouter = "cotizacionGrupo";                            
            break;
        case 5:
            nameRouter = "cotizacionSport";
            break;
        case 6:
            nameRouter = "cotizacionFunerario";
            break;
        }
    return nameRouter;
}

export function isRequiere(p_requierValue, p_fields, p_list){
    if (p_requierValue == '1') {
        p_list.push(p_fields);
    }
}

export function createObjectCR(p_tipoSeguro, p_fields, p_userLogin, p_planList, p_pasajeroList, p_ltsVariable) {
    let object = new Object();
    let factor = 0;
    let idDeporte = null;
    let anoPasajeroDestino = null;
    if (p_tipoSeguro == 1) {
        anoPasajeroDestino = parseInt(p_ltsVariable.ano_pasajero_destino_viaje);
    } else if (p_tipoSeguro == 2) {
        factor = p_fields.data[this.fields.factor].value;
    } else if (p_tipoSeguro == 4) {
        factor = p_fields.data[this.fields.factor].value;
    } else if (p_tipoSeguro == 5) {
        factor = p_fields.data[this.fields.factor].value;
        idDeporte = p_fields.data[this.fields.id_deporte].value;
    }
    object = {tipo_seguro: p_tipoSeguro,
              vigencia_desde: p_fields.data[p_fields.fecha_salida].value,
              vigencia_hasta: p_fields.data[p_fields.fecha_llegada].value,
              factor: factor,
              id_agencia: p_fields.data[p_fields.id_agencia].value,
              id_deporte: idDeporte,
              fecha_cotizacion: p_fields.data[p_fields.fecha_cotizacion].value,
              nota_cotizacion: p_fields.data[p_fields.nota_cotizacion].value,
              dias_vigencia: p_fields.data[p_fields.dias_vigencia].value,
              nota_vigencia: p_fields.data[p_fields.nota_vigencia].value,
              fecha_vigencia: p_fields.data[p_fields.fecha_vigencia].value,
              fecha_salida: p_fields.data[p_fields.fecha_salida].value,
              fecha_llegada: p_fields.data[p_fields.fecha_llegada].value,
              id_pais_origen: p_fields.data[p_fields.id_pais_origen].value,
              id_origen: p_fields.data[p_fields.id_origen].value,
              id_destino: p_fields.data[p_fields.id_destino].value,
              dias_viaje: p_fields.data[p_fields.dias_viaje].value,
              mascota: p_fields.data[p_fields.mascota].value,
              pasajero_destino: p_fields.data[p_fields.pasajero_destino].value,
              ano_pasajero_destino: anoPasajeroDestino,
              ultima_salida_pais: p_fields.data[p_fields.ultima_salida_pais].value,
              estudiante: p_fields.data[p_fields.estudiante].value,
              nota_pasajero_destino: p_fields.data[p_fields.nota_pasajero_destino].value,
              titular_nombre: p_fields.data[p_fields.titular_nombre].value,
              titular_id_sexo: p_fields.data[p_fields.titular_id_sexo].value,
              titular_apellido: p_fields.data[p_fields.titular_apellido].value,
              titular_correo: p_fields.data[p_fields.titular_correo].value,
              titular_fecha_nacimiento: p_fields.data[p_fields.titular_fecha_nacimiento].value,
              titular_edad: p_fields.data[p_fields.titular_edad].value,
              titular_viaja: p_fields.data[p_fields.titular_viaja].value,
              total_pvp: p_fields.data[p_fields.total_pvp].value,
              lista_categoria: p_planList,
              lista_pasajero: p_pasajeroList,
              id_idioma: p_userLogin.id_idioma,
              id_cotizacion: 0,
              id_metodo_pago: p_fields.data[p_fields.id_metodo_pago].value,
              numero: p_fields.data[p_fields.numero].value,
              nombre: p_fields.data[p_fields.nombre].value,
              cvv: p_fields.data[p_fields.cvv].value,
              caducidad: p_fields.data[p_fields.caducidad].value,
              observacion: p_fields.data[p_fields.observacion].value,
              tipo_validacion: p_fields.data[p_fields.tipo_validacion].value,
              validado: p_fields.data[p_fields.validado].value,
              fecha_validacion: p_fields.data[p_fields.fecha_validacion].value,
              codigo_validacion: p_fields.data[p_fields.codigo_validacion].value,
              monto_validacion: p_fields.data[p_fields.monto_validacion].value,
              id_validacion: p_fields.data[p_fields.id_validacion].value,
              url_validacion: p_fields.data[p_fields.url_validacion].value}
    return object;
} 


// WEBPACK FOOTER //
// ./src/assets/js/library.js